import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-automated',
  templateUrl: './automated.component.html',
  styleUrls: ['./automated.component.scss']
})
export class AutomatedComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) tb: Tablev2Component;
  public selected_company;
  constructor(private http: HttpService, private cdr : ChangeDetectorRef) { 
    this.http.getSelectedCompany().subscribe(res => {
      this.selected_company = res;
    });
  }

  ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/automated/get", data: {}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Name', type: 'string', key: 'name'}, 
            {label: 'Type', type: 'string', key: 'type'}, 
            {label: 'Trigger Time', type: 'string', key: 'trigger_time'}, 
            {label: 'Commission Level', type: 'string', key: 'commission_level'}, 
            {label: 'Wallet Type', type: 'string', key: 'wallet_type'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + (this.selected_company) + "/setting-automated/form", hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }
}
